<template lang="html">
  <section class="buttons">
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <h4 class="h2">Campaign status</h4>
            {{ $route.params.campaignId }}
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios'
let server = require('../../server')
export default {
  name: 'campaignStatus',
  campaign: null,
  async mounted () {
    let campaignId = this.$route.params.campaignId.toString()
    let self = this
    try {
      await axios({
        method: 'get',
        url: server.SERVER_URL + '/get_campaign_by_id/' + campaignId
      })
        .then(function (response) {
          console.log('getCampaign = ')
          console.log(response)
          self.campaign = response.data
        })
    } catch (e) {
      console.log('Error while trying to get users!')
      console.log(e)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/basic-elements/campaignStatus.vue